import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const AIAgentsPage: React.FC = () => {
  return <ServicePageTemplate slug="ai-agents" />;
};

export default AIAgentsPage;
